import { Route } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";

//import Registration from "./pages/registration";
//import Home from "./pages/home";
import ProfessionalProfile from "./pages/professional_profile";
import HealthProfile from "./pages/health_profile";
import PatientProfile from "./pages/patient_profile";
//import MyRecords from "./pages/my_records";
//import Settings from "./pages/settings";
import Login from "./pages/login";

import AuthProvider from "./contexts/AuthContext";
import PrivateRoute from "./services/private_route";
import store from "./services/store";
import AcceptInvite from "./pages/acceptinvite";
import PatientList from "./pages/patient_list";
import Contact from "./pages/contact";
import Newnotification from "./pages/newnotification";
import Profilecard from "./pages/profilecard";
//import AcceptAndValidate from "./components/login/acceptandvalidate";
import ValidateOtp from "./components/login/validateotp";
import DashboardList from "./pages/dashboard_list";
import DownloadForm from "./pages/downloadform";
import ProcessForm from "./pages/referral/processform";
import ReferralIndex from "./pages/referral/referralindex";
import ReferralDetails from "./pages/referral/referraldetails";
import Resources from "./pages/referral/resources";
import WhoAreYou from "./pages/referral/whoareyou";
import ReferrerLogin from "./pages/referral/referrerlogin";
import ReferrerRegister from "./pages/referral/referrerregister";
import ScreenProcess from "./pages/referral/screenprocess";
import UpdateAccount from "./pages/referral/updateaccount";
import SplashPage from "./pages/referral/splashpage";
import ReferralPatients from "./pages/referral/referralpatients";
import ReferralApps from "./pages/referral/referralapps";
import Epilepsy_Dashboard from "./pages/epilepsydashboard";
import AISummaryDashboard from "./pages/aisummarydashboard";
//import Registration from "./pages/registration";

let persistor = persistStore(store);

function App() {
  return (
      <div className="App">
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <AuthProvider>
              <PrivateRoute exact path="/" component={PatientList} />
              <PrivateRoute exact path="/dashboards" component={DashboardList} />
               {/* <Route exact path="/registration" component={Registration} />  */}
              <Route exact path="/login" component={Login} />
              <Route exact path="/invite/:id" component={AcceptInvite} />
              <Route exact path="/validateotp/:id" component={ValidateOtp} />
              <Route exact path="/downloadform/:id" component={DownloadForm} />
              <Route exact path="/referral/processform/:orgCode/:id" component={ProcessForm} />
              <Route exact path="/referral/details/:orgCode/:referralId" component={ReferralDetails} />
              <Route exact path="/referral/information/:orgCode" component={ReferralIndex} />
              <Route exact path="/referral/whoareyou/:orgCode" component={WhoAreYou} />
              <Route exact path="/referral/resources/:orgCode" component={Resources} />
              <Route exact path="/referral/login/:orgCode" component={ReferrerLogin} />
              <Route exact path="/referral/register/:orgCode" component={ReferrerRegister} />
              <Route exact path="/referral/screenprocess/:orgCode" component={ScreenProcess} />
              <Route exact path="/referral/updateaccount/:orgCode" component={UpdateAccount} />
              <Route exact path="/referral/patients/:orgCode" component={ReferralPatients} />
              <Route exact path="/referral/:orgCode" component={SplashPage} />
              <Route exact path="/referral" component={ReferralApps} />
              <PrivateRoute exact path="/professional_profile" component={ProfessionalProfile} />
              <PrivateRoute exact path="/health_profile" component={HealthProfile} />
              <PrivateRoute exact path="/patient_profile" component={PatientProfile} />
              <PrivateRoute exact path="/epilepsy_dashboard" component={Epilepsy_Dashboard} />
              <PrivateRoute exact path="/aisummarydashboard/:pathway/:organizationId" component={AISummaryDashboard} />
              <PrivateRoute exact path="/contact" component={Contact} />
              <PrivateRoute exact path="/newnotification" component={Newnotification} />
              <PrivateRoute exact path="/profilecard" component={Profilecard} />
            </AuthProvider>
          </PersistGate>
        </Provider>
      </div>
    
  );
}

export default App;
